import { AlertContext } from "contexts/AlertProvider";
import { useContext } from "react";

const useAlert = ()=>{
  return useContext(AlertContext)
}   

export default useAlert;